module.exports = {"632822100":"察汉乌苏镇","632822101":"香日德镇","632822102":"夏日哈镇","632822103":"宗加镇","632822200":"热水乡","632822201":"香加乡","632822202":"沟里乡","632822203":"巴隆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632822.json
// module id = 2807
// module chunks = 0